import { RootState } from "store/store";

const selectStatusPlan = (state: RootState) => state.statusSlice.statusPlan;

export const selectHasStacks = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasStacks;
  };
  (selector as any)._fromSelector = "hasStacksSelector";
  return selector;
};

export const selectHasPallet = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasPallet;
  };
  (selector as any)._fromSelector = "hasPalletSelector";
  return selector;
};

export const selectHasCage = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasCage;
  };
  (selector as any)._fromSelector = "hasCageSelector";
  return selector;
};

export const selectHasInventory = (gridElementId: string) => {
  const selector = (state: RootState): boolean => {
    const data = selectStatusPlan(state).find(s => s.id === gridElementId);

    if (!data) return false;
    return data?.hasInventory;
  };
  (selector as any)._fromSelector = "hasInventorySelector";
  return selector;
};
